module.exports = __webpack_public_path__ + "img/19.0d152ac0.jpg";